import {useQuery, UseQueryOptions} from '@tanstack/react-query'
import {QUERY_KEYS} from '@/queryClient'
import {
    httpGetSiarBulkExportPreviewCounters,
    HttpGetSiarBulkExportPreviewCountersParams,
    HttpGetSiarBulkExportPreviewCountersResponse
} from '@/features/projects/siar-bulk-export/http/siarBulkExport.http'

export const useGetSiarBulkExportPreviewCounters = (
    params: HttpGetSiarBulkExportPreviewCountersParams,
    options?: Pick<UseQueryOptions<HttpGetSiarBulkExportPreviewCountersResponse>, 'enabled'>
) =>
    useQuery({
        queryKey: [QUERY_KEYS.SIAR_BULK_EXPORT_PREVIEW_COUNTERS, params],
        queryFn: () => httpGetSiarBulkExportPreviewCounters(params),
        ...options
    })
